// Browser-side Supabase client.
//
// Reads URL + anon key from Vite env (build-time inlined). Returns
// null if either is missing — the bridge degrades to a fixture-only
// fallback in that case so `npm run web:dev` still produces something
// useful before the developer configures Supabase.

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

let _client = null;
let _warned = false;

export function getSupabase() {
  if (_client) return _client;
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    if (!_warned) {
      console.warn(
        '[lastslate-web] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing — running in fixture-only fallback mode. Auth + cloud storage are disabled.',
      );
      _warned = true;
    }
    return null;
  }
  _client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // Use the implicit/PKCE flow so the auth callback exchange is
      // handled inline by supabase-js — see bridge/auth.js.
      flowType: 'pkce',
    },
  });
  return _client;
}

export function hasSupabase() {
  return getSupabase() !== null;
}
